import React, { PureComponent } from 'react';
import classNames from 'classnames';

import { translate as t } from '../../../translations';
import { Icon } from '@lumapps/lumx/react';
import { mdiInformationOutline } from '@lumapps/lumx/icons';

import { PROGRESS_TYPE } from './constant';
import { Progress } from './Progress';

/**
 * Display a circular or a linear loader (Lumx like).
 * The loader can also display a "no-results".
 */
export class Loader extends PureComponent {
    static defaultProps = {
        color: 'primary',
        hasBackground: false,
        hasNoResults: false,
        isLoading: true,
        type: PROGRESS_TYPE.CIRCULAR,
    };

    render() {
        const { color, hasBackground, hasNoResults, isLoading, noResultsText, type } = this.props;

        return (
            <div
                className={classNames('loader', `loader--${type}`, {
                    'loader--has-background': hasBackground,
                    'loader--no-results': hasNoResults,
                })}
            >
                {isLoading && !hasNoResults && <Progress color={color} diameter="50" type={type} />}

                {hasNoResults && (
                    <div className={classNames('no-results', { hasBackground: 'no-results--has-background' })}>
                        <Icon icon={mdiInformationOutline} />
                        <span>{noResultsText ? noResultsText : t('NO_RESULTS')}</span>
                    </div>
                )}
            </div>
        );
    }
}
